var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('VsLoader',{attrs:{"visible":_vm.showLoader}}),(_vm.chartData)?[_c('TopChart',{attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions,"styles":{
        width: '95%',
        margin: 'auto',
      }}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }